import { createIntl } from 'react-intl-next';

import { ConditionFilterMessages } from '../../../../common/messages';

const { formatMessage } = createIntl({ locale: 'en' });

export const PRIORITY_MAP = {
	P1: {
		label: formatMessage(ConditionFilterMessages.PriorityCritical),
		value: 'P1',
	},
	P2: {
		label: formatMessage(ConditionFilterMessages.PriorityHigh),
		value: 'P2',
	},
	P3: {
		label: formatMessage(ConditionFilterMessages.PriorityModerate),
		value: 'P3',
	},
	P4: {
		label: formatMessage(ConditionFilterMessages.PriorityLow),
		value: 'P4',
	},
	P5: {
		label: formatMessage(ConditionFilterMessages.PriorityInformational),
		value: 'P5',
	},
} as const;
